<script setup>
import { computed, onMounted, watch } from "vue";
import { useStore } from "vuex";
import { waitForWindowVariable } from "common/utils/ui/wait_for";

const props = defineProps({
  disabled: {
    default: false,
    type: Boolean
  }
});

const id = "js-stripe-element";
const store = useStore();

const countryCode = computed(() => store.getters["checkout/countryCode"]);
const csrfToken = computed(() => store.getters["checkout/csrfToken"]);
const currency = computed(() => store.getters["checkout/currency"]);
const locale = computed(() => store.getters["checkout/locale"]);
const orderNumber = computed(() => store.getters["checkout/orderNumber"]);
const pageSource = computed(() => store.getters["checkout/pageSource"]);
const publishableKey = computed(() => store.getters["checkout/publishableKey"]);
const stripeLineItems = computed(() => store.getters["checkout/stripeLineItems"]);
const stripeShippingRates = computed(() => store.getters["checkout/stripeShippingRates"]);
const totalAmountInCents = computed(() => store.getters["checkout/totalAmountInCents"]);
const userType = computed(() => store.getters["checkout/userType"]);

const loadStripeButtons = () => {
  if (!publishableKey.value || !totalAmountInCents.value) return;

  waitForWindowVariable("Stripe", () => {
    window?.jiffyThreads?.payments.loadStripeButtons(`#${id}`, () => ({
      buttonHeight: 52,
      countryCode: countryCode.value,
      csrfToken: csrfToken.value,
      currency: currency.value,
      locale: locale.value,
      orderNumber: orderNumber.value,
      pageSource: pageSource.value,
      publishableKey: publishableKey.value,
      stripeLayout: {
        maxColumns: 1,
        maxRows: 0,
        overflow: "never"
      },
      stripeLineItems: stripeLineItems.value,
      stripeShippingRates: stripeShippingRates.value,
      totalAmountInCents: totalAmountInCents.value,
      userType: userType.value
    }));
  });
};

watch(
  () => totalAmountInCents.value,
  (newAmount, oldAmount) => {
    if (newAmount && newAmount !== oldAmount) {
      loadStripeButtons();
    }
  }
);
onMounted(() => {
  loadStripeButtons();
});
</script>

<template>
  <div :id="id" class="stripe" :class="{ 'stripe--disabled': props.disabled }"></div>
</template>

<style scoped lang="scss">
.stripe {
  &--disabled {
    pointer-events: none;
    opacity: 0.5;
  }
}
</style>
